import SlideDown from 'react-slidedown';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Chevron } from 'assets/images/chevron-small.svg';

import { Info } from '../styles';

type PolicyStatusProps = {
  $valid: boolean;
};

type ToggleProps = {
  $detailsOpen: boolean;
};

export const DetailsSlideDown = styled(SlideDown)`
  transition-duration: 0.2s;
  width: 100%;
`;

export const Content = styled.div`
  /* use padding, so it doesn't affect SlideDown calcs */
  padding: 0 24px 16px 24px;

  & ${Info} {
    margin: 4px 0;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 24px;
  border-top: 1px solid ${ColorPalette.HEX.BrightGray3};
`;

export const PolicyStatus = styled.p<PolicyStatusProps>`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;

  color: ${({ $valid }) => ($valid ? ColorPalette.HEX.GreenPantone : ColorPalette.HEX.RedRYB)};
`;

export const DropdownChevron = styled(Chevron)`
  width: 16px;
  height: 16px;
`;

export const ToggleDetails = styled.button<ToggleProps>`
  display: inline-block;
  margin: 16px 0 16px auto;
  background-color: ${ColorPalette.Transparent};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${ColorPalette.HEX.DimGray};
  cursor: pointer;

  & ${DropdownChevron} {
    width: 10px;
    height: 10px;
    margin-left: 8px;
    vertical-align: middle;
    transform: ${({ $detailsOpen }) => ($detailsOpen ? 'rotate(270deg)' : 'rotate(90deg)')};
  }
`;
